<template>
  <div class="container">
    <div class="flex justify-center w-full mx-auto mb-8 xl:mb-16">
      <div
        class="step"
        :class="step == 1 ? 'active' : 'passed'"
        :aria-disabled="step !== 1"
      >
        <div class="indicator">
          <div v-if="step > 1" class="w-3">
            <svg viewBox="0 0 15.933 14" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'text-white fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.425 5.369L0 8.349 6.942 14l8.99-11.653L12.891 0 6.309 8.531 2.425 5.369"/></svg>
          </div>
          <div v-else>
            1
          </div>
        </div>
        <div class="text">
          {{ $t('components.navigation.step1') }}
        </div>
      </div>

      <div
        class="step"
        :class="step == 2 ? 'active' : ''"
        :aria-disabled="step !== 2"
      >
        <div class="indicator">
          <div>
            2
          </div>
        </div>
        <div class="text">
          {{ $t('components.navigation.step2') }}
        </div>
      </div>

      <div class="step" aria-disabled>
        <div class="indicator">
          <div>
            3
          </div>
        </div>
        <div class="text">
          {{ $t('components.navigation.step3') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style lang="scss" scoped>
.step {
  @apply w-1/3 flex items-center justify-center relative pt-3 pr-2;

  &::before {
    content: "";

    @apply absolute left-0 top-0 w-full h-2px bg-sw_gray-300;
  }

  .indicator {
    @apply w-5 h-5 rounded-full text-xxs flex items-center justify-center leading-none flex-shrink-0 text-white mr-2 bg-sw_gray-300;
  }

  .text {
    @apply text-xxs text-sw_gray-300 leading-none;
  }

  &:first-child {
    @apply justify-start;
  }

  &:last-child {
    @apply justify-end;
  }

  &.active {
    @apply font-bold;

    &::before {
      @apply bg-sw_primary;
    }

    .indicator {
       @apply bg-sw_primary;
    }

    .text {
      @apply text-black;
    }
  }

  &.passed {
    &::before {
      @apply bg-sw_primary;
    }

    .indicator {
       @apply bg-sw_yellow_error-text;
    }

    .text {
      @apply text-sw_yellow_error-text;
    }
  }

}

@screen xl {
  .step {
    @apply pt-4;

    .indicator {
      @apply w-6 h-6 text-xs;
    }

    .text {
      @apply text-base;
    }
  }
}
</style>
